<template lang="html">
  <div class="accordion" :id="idgroup">
    <div
      class="accordion-head"
      :class="show ? '' : 'collapsed'"
      data-toggle="collapse"
      :data-target="'#' + id"
    >
      {{ title }} <v-icon name="arrow-down" />
    </div>
    <div
      class="accordion-body collapse"
      :id="id"
      :class="show ? 'show' : ''"
      :data-parent="'#' + group"
    >
      <div class="accordion-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id', 'group', 'title', 'show'],
};
</script>

<style lang="scss">
.accordion {
  .accordion-head {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

    padding: 1em;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    color: color(primary);
    font-size: 1.25em;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      transform: rotate(180deg);
      transition: 0.4s;
      display: inline-block;
      font-size: 24px;
    }
    &.collapsed {
      .icon {
        transform: rotate(360deg);
      }
    }
  }
  .accordion-body {
  }
  .accordion-inner {
    background: #fff;
    padding: 1em;
    border-bottom: 1px solid #ddd;
    margin-bottom: 1em;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/accordion.vue